import { render, staticRenderFns } from "./last.vue?vue&type=template&id=8eaded1a&scoped=true&"
var script = {}
import style0 from "./last.vue?vue&type=style&index=0&id=8eaded1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eaded1a",
  null
  
)

export default component.exports